import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'bootstrap';
import { Select, SelectType } from '@components/atoms/Select';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { ResultsType } from '@types';
import styles from './ResultsPageTop.module.css';

export interface ResultsPageTopProps {
    type: ResultsType;
    total: number;
    order: {
        value?: string;
        options: { value: string; text: string }[];
        onChange: (value: string) => void;
    };
    sidebar: Collapse | null;
}

export const ResultsPageTop: FC<ResultsPageTopProps> = ({ type, total, order, sidebar }) => {
    const { t } = useTranslation();

    const translations = {
        totalSpaces: t('results-container-component.spaces'),
        filterLabel: t('results-container-component.filter.label'),

    };

    const openSidebar = () => {
        sidebar?.show();
    };

    const getTotalText: () => string = useCallback(() => {
        switch (type) {
            case ResultsType.spaces:
                return translations.totalSpaces;
            default:
                return '';
        }
    }, [type, translations.totalSpaces]);

    return (
        <>
            <div className="d-flex align-items-center pb-3">
                <div className={`${styles['total-results']} d-none d-lg-grid flex-grow-1 align-content-center`}>
                    <Typography classes="mb-0 d-flex gap-2" fontSize="16">
                        <>
                            <Typography tagVariant={TypographyTagVariants.span} fontWeight="900">
                                {total}
                            </Typography>{' '}
                            {getTotalText()}
                        </>
                    </Typography>
                </div>
                <div className="d-block d-lg-none flex-grow-1">
                    <button onClick={openSidebar}>
                        <i className="fa-light fa-filter me-2" />
                        {translations.filterLabel}
                    </button>
                </div>
                {!!order.options.length && (
                    <div className="d-flex align-items-center">
                        {/* <Typography classes="d-none d-lg-block text-nowrap mb-0 me-3" fontSize="16">
                            {translations.orderByLabel}
                        </Typography> */}
                        <div className="ms-3">
                            <Select type={SelectType.variant2} width="250px" {...order} />
                        </div>
                    </div>
                )}
            </div>
            {/*<hr className="mt-0 mb-3" />*/}
        </>
    );
};
